<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:right-content="page.rightContent"
		/>

		<section class="main-content cookie-content align-center background-light">
			<div v-if="cookies.size > 0" :key="locale" class="row">
				<div class="columns column12">
					<h2>Cookies</h2>
					<div
						v-for="category in ['Necessary', 'Performance', 'Functional', 'Advertising', 'Unclassified']"
						:key="category"
						class="cookie-category"
					>
						<div v-if="cookies.has(category.toLowerCase())">
							<h4>{{ $t(`consentCategory${category}`) }}</h4>
							<div v-if="category !== 'unclassified'">
								<div v-html="defaults[locale].cookieConsent[`content${category}`]" />
							</div>
							<div class="responsive-table">
								<table class="cookie-table">
									<colgroup>
										<col style="width: 20%" />
										<col style="width: 15%" />
										<col style="width: 55%" />
										<col style="width: 10%" />
									</colgroup>
									<thead>
										<tr>
											<th>{{ $t('consentCookieName') }}</th>
											<th>{{ $t('consentCookieProvider') }}</th>
											<th>{{ $t('consentCookiePurpose') }}</th>
											<th>{{ $t('consentCookieExpiry') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="cookie in cookies.get(category.toLowerCase())" :key="cookie.name">
											<td>{{ cookie.name }}</td>
											<td>
												<a v-if="cookie.q2" target="_blank" :href="cookie.q2">
													{{ cookie.q1 }}
												</a>
												<span v-else>{{ cookie.q1 }}</span>
											</td>
											<td>{{ cookie.desc }}</td>
											<td>{{ cookie.expiration_time }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:contentblocks-content="page.contentBlockContent"
		/>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection && page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletterForm.title"
			:content="defaults[locale].newsletterForm.content"
			:email="defaults[locale].newsletterForm.email"
			:button="defaults[locale].newsletterForm.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const { cfInit, cfDestroy } = useCookieConsent();

await fetchPage();
await fetchDefaults();

const cookies = ref(new Map());

onMounted(() => {
	cfInit(initCookieFirst);
});

onBeforeUnmount(() => {
	cfDestroy();
});

const initCookieFirst = () => {
	window.CookieFirst.fetchLatestScan()
		.then((result) => {
			cookies.value = getCookiesByCategory(result.cookies);
		})
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.error(error);
		});
};

const getCookiesByCategory = (cookies) => {
	const cookiesByCategory = new Map();

	cookies.forEach(function (cookie) {
		if (!cookiesByCategory.has(cookie.cat)) {
			cookiesByCategory.set(cookie.cat, []);
		}
		cookiesByCategory.get(cookie.cat).push(cookie);
	});

	return cookiesByCategory;
};
</script>

<style lang="scss" scoped>
.cookie-content {
	padding-top: 0;
}

.responsive-table {
	width: 100%;
	overflow-x: auto;
}

table {
	width: 100%;
	min-width: 800px;
	text-align: left;
}

table th {
	font-weight: 700;
}

table th,
table td {
	border-bottom: 1px solid #ccc;
	padding: 10px;
}

table a {
	text-decoration: none;
}

.cookie-category {
	margin: 25px 0;
}

.cookie-list .button {
	margin-bottom: 50px;
}
</style>
